import { render, staticRenderFns } from "./openDiagnostic.vue?vue&type=template&id=2a432416&scoped=true"
import script from "./openDiagnostic.vue?vue&type=script&lang=ts"
export * from "./openDiagnostic.vue?vue&type=script&lang=ts"
import style0 from "./openDiagnostic.vue?vue&type=style&index=0&id=2a432416&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a432416",
  null
  
)

export default component.exports